<div class="field col-12">
    <label>{{pergunta.detalhesTitulo}}</label>

    <p-calendar [showTime]="true" [showSeconds]="false" [(ngModel)]="pergunta.resposta" [disabled]="!habilitado"
        (ngModelChange)="respostaAlterada()"></p-calendar>
</div>